import { render, staticRenderFns } from "./CoffeeOrders.vue?vue&type=template&id=a530a224&scoped=true&"
import script from "./CoffeeOrders.vue?vue&type=script&lang=js&"
export * from "./CoffeeOrders.vue?vue&type=script&lang=js&"
import style0 from "./CoffeeOrders.vue?vue&type=style&index=0&id=a530a224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a530a224",
  null
  
)

export default component.exports